import { styled } from '@mui/system';
import { Box, Typography, Stack,  } from '@mui/material';

import { EmojiSad } from "assets/icons";

const WarningBoxRoot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.red[100],
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1)
}));

const HeaderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  "& > svg": {
    margin: theme.spacing(0, 2, 0, 1)
  },
  ".MuiTypography-root": {
    color: theme.palette.red[900],
    margin: theme.spacing(0, 1),
    fontSize: '1rem'
  }
}));

const WarningBox = ({ title, onCancel, ...props }) => {

  return (
    <WarningBoxRoot {...props}>
      <Stack direction='row' justifyContent='space-between' alignItems='start'>
        <HeaderBox>
          <EmojiSad />
          <Typography sx={{ whiteSpace: 'pre-wrap' }}>{title}</Typography>
        </HeaderBox>
      </Stack>
    </WarningBoxRoot >
  );
}

export default WarningBox;
